<div class="completed-action-info container">

  <div class="completed-action-info__left">
    <ng-container *ngTemplateOutlet="leftContent"></ng-container>
  </div>

  <div class="completed-action-info__right">
    <div class="completed-action-info__title">
      {{ data.title | translate }}
    </div>

    <button class="btn btn--clear completed-action-info__button"
            (click)="onButtonClick()">
      {{ data.buttonLabel | translate }}
      <span class="material-icons">arrow_right</span>
    </button>
  </div>
</div>
